export interface ReferralRewards {
    enabled: boolean;
    referrer_text_credits: number;
    referrer_voice_credits: number;
    referred_text_credits: number;
    referred_voice_credits: number;
}

export interface AdsgramConfig {
    enabled: boolean;
    block_id: string;
    reward_text_credits: number;
    max_ads_per_day: number;
}

export interface BoosterPack {
    stars_price: number;
    text_credits?: number;
    voice_credits: number;
    duration_days?: number;
    enabled: boolean;
    title?: string;
    description?: string;
    icon_type?: "message" | "mic" | "ticket";
}

export interface TierLimit {
    text_per_day?: number;
    voice_per_day?: number;
}

export interface ActiveSale {
    enabled: boolean;
    discount_percent: number;
    applies_to: string[];
    banner_text?: string;
    ends_at?: Date | null;
}

export interface XPRewardsConfig {
    roleplay_complete: number;
    study_complete: number;
    assessment_complete: number;
    daily_login: number;
    referral_complete: number;
    share: number;
    streak_bonus_per_day: number;
    streak_bonus_cap: number;
}

export interface DailyRewardDay {
    text_credits: number;
    voice_credits: number;
}

export interface DailyLoginRewardsConfig {
    schedule: DailyRewardDay[];
}

export interface PricingConfig {
    pro_monthly_stars: number;
    pro_yearly_stars: number;
    booster_packs: Record<string, BoosterPack>;
    promo_codes_enabled: boolean;
    active_sale: ActiveSale;
    referral_rewards: ReferralRewards;
    adsgram: AdsgramConfig;
    tier_limits: {
        free: TierLimit;
        pro: TierLimit;
    };
    gemini_cost_per_1m_tokens: number;
    // Feature flags
    certificates_enabled: boolean;
    leaderboard_enabled: boolean;
    coupons_enabled: boolean;
    // Gamification
    xp_rewards: XPRewardsConfig;
    daily_login_rewards: DailyLoginRewardsConfig;
    updated_at?: any;
    updated_by?: string;
}

export const DEFAULT_CONFIG: PricingConfig = {
    pro_monthly_stars: 750,
    pro_yearly_stars: 6000,
    booster_packs: {
        starter: { stars_price: 100, text_credits: 50, voice_credits: 5, enabled: true, title: "Starter", icon_type: "message" },
        study_session: { stars_price: 250, text_credits: 200, voice_credits: 25, enabled: true, title: "Study Session", icon_type: "mic" },
        power_pack: { stars_price: 500, text_credits: 600, voice_credits: 80, enabled: true, title: "Power Pack", icon_type: "mic" },
        weekly_pass: { stars_price: 625, voice_credits: 125, duration_days: 7, enabled: true, title: "Weekly Pass", icon_type: "ticket" },
    },
    promo_codes_enabled: true,
    active_sale: {
        enabled: false,
        discount_percent: 0,
        applies_to: [],
        banner_text: "",
        ends_at: null,
    },
    referral_rewards: {
        enabled: true,
        referrer_text_credits: 50,
        referrer_voice_credits: 10,
        referred_text_credits: 25,
        referred_voice_credits: 5,
    },
    adsgram: {
        enabled: false,
        block_id: "int-1234",
        reward_text_credits: 5,
        max_ads_per_day: 3,
    },
    tier_limits: {
        free: { text_per_day: 10, voice_per_day: 0 },
        pro: { text_per_day: undefined, voice_per_day: undefined },
    },
    gemini_cost_per_1m_tokens: 0.075,
    certificates_enabled: false,
    leaderboard_enabled: false,
    coupons_enabled: false,
    xp_rewards: {
        roleplay_complete: 50,
        study_complete: 30,
        assessment_complete: 100,
        daily_login: 10,
        referral_complete: 25,
        share: 5,
        streak_bonus_per_day: 5,
        streak_bonus_cap: 50,
    },
    daily_login_rewards: {
        schedule: [
            { text_credits: 2, voice_credits: 0 },
            { text_credits: 2, voice_credits: 0 },
            { text_credits: 5, voice_credits: 0 },
            { text_credits: 5, voice_credits: 0 },
            { text_credits: 5, voice_credits: 1 },
            { text_credits: 5, voice_credits: 1 },
            { text_credits: 10, voice_credits: 2 },
        ],
    },
};
